import React from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer"; 
import homebanner from "../assets/home-banner.png"; 
import Pagetitlesection from "../components/pagetitlesection";
import { FiPhoneCall, FiMail, FiMessageCircle } from "react-icons/fi";

function Support() {
  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title="GIFFYPEDIA Customer Support" backgroundImage={homebanner} />

  <div className="md:container mx-auto px-6 sm:px-6 py-10 flex flex-col items-center justify-center min-h-[40vh] text-center">
 

          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            Our <strong>24x7 customer support team</strong> is available via 
            <span className="inline-flex items-center gap-2 mx-2 text-blue-600 font-medium">
              <FiPhoneCall /> Calls,
            </span>
            <span className="inline-flex items-center gap-2 mx-2 text-green-600 font-medium">
              <FiMail /> Email,
            </span>
            <span className="inline-flex items-center gap-2 mx-2 text-purple-600 font-medium">
              <FiMessageCircle /> Chat
            </span>
            — all cost-free.
          </p>

          <p className="text-gray-600 text-base leading-relaxed">
            Access our technical support team anytime for ticket placement, phone calls, chat options, and entry to the GiffyPedia digital support communities and blogs.
          </p>
 
  <br/>
   
 
</div>

        <Footer />
      </div>
    </>
  );
}

export default Support;
